import $ from 'jquery';
import initNavigationMenuButton from './common/initNavigationMenuButton';
import initNavigationDropdownList from './common/initNavigationDropdownList';
import initFooterMenu from './common/initFooterMenu';
import initCookiesBar from './common/initCookiesBar';
import enableSocialButtons from './common/enableSocialButtons';
import setBookingLink from './setBookingLink';
import includeCustomerChat from './common/includeCustomerChat';
import includeLinechat from './common/includeLinechat';
import getWordingJson from './request/wordingJson';
import wordingSetter from './wordingSetter';
import urlParser from './urlParser';

const setup = () => {
	/**
	 * get common.json for wording and replace them on DOM
	 */
	getWordingJson()
		.then((json) => {
			wordingSetter(json);

			if (urlParser.language === 'tw' && window.innerWidth < 992) {
				Array.from(document.querySelectorAll('.dropdown-button.-branch > .list > .option'))
					.forEach((option) => {
						option.textContent = option.textContent.substr(2, 2);
					});
			}
		});
	includeCustomerChat();
	includeLinechat();
	initNavigationMenuButton();
	initNavigationDropdownList();
	initFooterMenu();
	initCookiesBar();
	enableSocialButtons();

	setBookingLink(
		$(".nav-bar > .lrblock > .-booking, .footer-wrapper .-booking"),
	);

	$("body").addClass(`-${urlParser.language}`);
};

export default setup;



// WEBPACK FOOTER //
// ./src/js/setupCommonJS.js